import { ERRORS } from '../Errors';
import { ResourceType } from '../resources/ResourceType';
export class Texture {
    constructor(renderer) {
        this.isDeleted = false;
        const gl = renderer.getGL();
        if (!renderer || !gl) {
            throw new Error(ERRORS.GL_CONTEXT_MISSING);
        }
        this.renderer = renderer;
        this.gl = gl;
        this.texture = this.renderer.resources.createResource(ResourceType.Texture);
        const textureId = this.texture.resource;
        if (!textureId) {
            throw new Error(ERRORS.TEXTURE_MISSING);
        }
    }
    static create(width, height, renderer) {
        const gl = renderer.getGL();
        const texture = new Texture(renderer);
        const internalFormat = gl.RGBA;
        const srcFormat = gl.RGBA;
        const srctype = gl.UNSIGNED_BYTE;
        texture.width = width;
        texture.height = height;
        gl.bindTexture(gl.TEXTURE_2D, texture.texture.resource);
        Texture.setupImage(gl);
        gl.texImage2D(gl.TEXTURE_2D, 0, internalFormat, width, height, 0, srcFormat, srctype, null);
        return texture;
    }
    dispose() {
        this.texture.delete();
        this.isDeleted = true;
    }
    load(url, subImage, xOff, yOff) {
        if (this.isDeleted) {
            return;
        }
        if (url instanceof Blob) {
            return this.loadBlob(url, subImage, xOff, yOff);
        }
        else if (typeof url === 'string') {
            return this.loadUrl(url, subImage, xOff, yOff);
        }
        else if (url instanceof Response) {
            return this.loadResponse(url, subImage, xOff, yOff);
        }
    }
    loadUrl(url, subImage, xOff, yOff) {
        return fetch(url, { mode: 'cors' }).then((data) => {
            if (!this.isDeleted) {
                return this.loadResponse(data, subImage, xOff, yOff);
            }
        });
    }
    loadResponse(data, subImage = false, xOff = 0, yOff = 0) {
        return data.blob().then((blob) => {
            if (!this.isDeleted) {
                return this.loadBlob(blob, subImage, xOff, yOff);
            }
        });
    }
    loadBlob(blob, subImage = false, xOff = 0, yOff = 0) {
        return this.createImage(blob).then((image) => {
            if (!this.isDeleted) {
                return this.loadImageData(image, subImage, xOff, yOff);
            }
        });
    }
    createImage(blob) {
        if (window.createImageBitmap) {
            return window.createImageBitmap(blob);
        }
        return this.createHtmlImage(blob);
    }
    createHtmlImage(blob) {
        return new Promise((resolve, reject) => {
            const objUrl = URL.createObjectURL(blob);
            const image = new Image();
            image.crossOrigin = 'Anonymous';
            image.onload = () => {
                image.onload = null;
                URL.revokeObjectURL(objUrl);
                resolve(image);
            };
            image.onerror = () => {
                image.onerror = null;
                URL.revokeObjectURL(objUrl);
                reject(image);
            };
            image.src = objUrl;
        });
    }
    loadImageData(image, subImage = false, xOff = 0, yOff = 0) {
        if (this.isDeleted) {
            return;
        }
        const gl = this.gl;
        const level = 0;
        const internalFormat = gl.RGBA;
        const srcFormat = gl.RGBA;
        const srctype = gl.UNSIGNED_BYTE;
        gl.bindTexture(gl.TEXTURE_2D, this.texture.resource);
        Texture.setupImage(gl);
        if (!subImage) {
            this.height = image.height;
            this.width = image.width;
            gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, srcFormat, srctype, image);
        }
        else {
            gl.texSubImage2D(gl.TEXTURE_2D, level, xOff, yOff, image.width, image.height, internalFormat, srctype, image);
        }
    }
    static setupImage(gl) {
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    }
    use() {
        if (this.isDeleted) {
            return;
        }
        this.gl.activeTexture(this.gl.TEXTURE0);
        this.gl.bindTexture(this.gl.TEXTURE_2D, this.texture.resource);
    }
}
//# sourceMappingURL=Texture.js.map